<template lang="pug">
UiDataTableTr
  UiDataTableTd(v-for="header in headers")
    template(v-if="header.key === 'symbol'")
      UiFormGroup(:vuelidateModel="v$.item.symbol")
        UiInput(
          :modelValue="item.symbol"
          @update:modelValue="item.symbol = normalizeSymbolValue($event)"
          maxlength="1"
          :error="v$.item.symbol.$error"
        )
    template(v-if="header.key === 'count'")
      UiFormGroup(:vuelidateModel="v$.item.count")
        UiInput(
          v-model.number="item.count"
          step="1"
          type="number"
          @keypress="strictNumberInput($event)"
          :error="v$.item.count.$error"
        )
    template(v-if="header.key === 'actions'")
      UiButton(
        variant="smooth-danger"
        size="sm"
        @click="$emit('delete')"
        icon="Trash"
      ) {{ $t("actions.delete") }}
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["delete"],

  props: {
    headers: {
      default: null,
    },
    items: {
      default: null,
    },
    item: {
      type: Boolean,
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      item: {
        symbol: {
          required,
        },
        count: {
          required,
        },
      },
    };
  },

  methods: {
    normalizeSymbolValue(value) {
      return value.replace(/[^a-zA-Z0-9]/).slice(-1);
    },

    strictNumberInput(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        event.preventDefault();
      } else {
        return true;
      }
    },
  },
});
</script>
